import React, { useState, useEffect } from "react";
import { Col, Image, Button, Form } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { getGroupByFavourites } from "../../../../store/actions/AdminAllUserFavourites/userAllFavourites";
import UserFavoritesRestaurant from "./InsidegroupPageComponent/UserFavoritesRestaurant";
import UserFavoritesOffers from "./InsidegroupPageComponent/UserFavoritesOffers";
import UserFavoritesEvents from "./InsidegroupPageComponent/UserFavoritesEvents";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
const SuperAdminMainUserFavoritesGroup = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [search, setSearch] = useState("");

  const pageChanger = (value) => {
    setSelectedTab(value);
  };

  const onErrorGetGroupBy = () => {
    setLoading(false);
  };
  const onSuccesGetGroupBy = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    props.getGroupByFavourites(
      selectedTab,
      onSuccesGetGroupBy,
      onErrorGetGroupBy
    );
  }, [selectedTab]);

  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    showFilter: false,
  });

  /*********************************
   * @DESC Search Bar Action
   *********************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const [dateQuery, setDateQuery] = useState({});

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    console.log(value);
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  return (
    <>
      {!loading ? (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation />
              <Col>
                <Col className="pt-4 pb-3">
                  <NavLink
                    to="/superadminuserfavorite"
                    className="f12-500 enBackLink"
                  >
                    <Image
                      fluid
                      alt="Back Icon"
                      title="Back Icon"
                      className="mr-2"
                      src={require("../../../../assets/images/UserManagement/backIcon.svg")}
                    />
                    Back
                  </NavLink>
                  <div className="f24_700_HelveticaNeue">Favourites</div>
                </Col>
              </Col>
              <Col className="px-4">
                <div className="row">
                  <div className="col-4">
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      name="search"
                      onChange={onSearchChange}
                      value={state.search}
                      className="amSearch"
                    />
                  </div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <div className="mr-3">
                      <SelectFilter onDateChange={onDateChangeHandler} />
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={state.anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                      <div className="f10-400" align="center">
                        <img
                          src={require("../../../../assets/images/iconButton/filtericon.png")}
                          width="35px"
                          alt="Filter Icon"
                        />
                        <br />
                        Filter
                      </div>
                      <div className="f10-400" align="center">
                        <img
                          src={require("../../../../assets/images/iconButton/downloadicon.png")}
                          width="35px"
                          alt="Download Icon"
                        />
                        <br />
                        Download
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <div className="super-admin-inside-right-side-panel">
                <div className="">
                  <div className="row align-items-center justify-content-between">
                    <div className="col-md-3 d-flex align-items-center">
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 1 ? "active" : ""
                        }`}
                        onClick={() => pageChanger(1)}
                      >
                        Restaurants
                      </Button>
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 2 ? "active" : ""
                        }`}
                        onClick={() => pageChanger(2)}
                      >
                        Offers
                      </Button>
                      <Button
                        variant="link"
                        className={`px-0 mr-4 text-grayLink f12-500 ${
                          selectedTab === 3 ? "active" : ""
                        }`}
                        onClick={() => pageChanger(3)}
                      >
                        Events
                      </Button>
                    </div>
                  </div>
                </div>
                {selectedTab === 1 ? (
                  <UserFavoritesRestaurant
                    groupByData={props.groupByFavourites}
                    selectedTab={selectedTab}
                    dateQuery={dateQuery}
                    search={state.search}
                    sortValue={state.restaurantReverse}
                  />
                ) : null || selectedTab === 2 ? (
                  <UserFavoritesOffers
                    groupByData={props.groupByFavourites}
                    selectedTab={selectedTab}
                    dateQuery={dateQuery}
                    search={state.search}
                    sortValue={state.restaurantReverse}
                  />
                ) : null || selectedTab === 3 ? (
                  <UserFavoritesEvents
                    groupByData={props.groupByFavourites}
                    selectedTab={selectedTab}
                    dateQuery={dateQuery}
                    search={state.search}
                    sortValue={state.restaurantReverse}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <AmealioLoader />
      )}
    </>
  );
};

UserFavoritesRestaurant.propTypes = {
  auth: PropTypes.object.isRequired,
  getGroupByFavourites: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  groupByFavourites: state.userManagement.groupByFavourites,
});

export default connect(mapStateToProps, {
  getGroupByFavourites,
})(SuperAdminMainUserFavoritesGroup);
